export default "<mat-spinner [diameter]=\"diameter\"></mat-spinner>\r\n";